import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID, APP_INITIALIZER } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import localePy from '@angular/common/locales/es';
import { registerLocaleData } from '@angular/common';

// Modules
import { AppRoutingModule } from './app-routing.module';
import { AngularFireModule } from '@angular/fire';
import { AngularFireAnalyticsModule } from '@angular/fire/analytics';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from './material-module/material.module';
import { MatCarouselModule } from '@ngmodule/material-carousel';
import { ServiceWorkerModule } from '@angular/service-worker';
import { NgxGalleryModule } from '@kolkov/ngx-gallery';

//Models

//Resolvers
import { SocialNetworkRegisterResolver } from './_resolvers/social-network-register.resolver';
import { UserEditResolver } from './_resolvers/user-edit.resolver';

// Services
import { DevicesService } from './_services/devices.service';
import { ProductService } from './_services/product.service';
import { SidenavService } from './_services/sidenav.service';


//Helper

//environments
import { environment } from 'src/environments/environment';

// Components
import { AlertDialogComponent } from './modals/alert-dialog/alert-dialog.component';
import { AppComponent } from './app.component';
import { CarouselPromotionalProfileComponent } from './components/profile/carousel-promotional-profile/carousel-promotional-profile.component';
import { EditProfileComponent } from './components/profile/edit-profile/edit-profile.component';
import { FiltersComponent } from './components/products/filters/filters.component';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from './components/header/header.component';
import { HomeComponent } from './components/home/home.component';
import { LoaderComponent } from './components/loader/loader.component';
import { LoginComponent } from './modals/login/login.component';
import { MenuComponent } from './components/menu/menu.component';
import { OrderHistoryComponent } from './components/profile/order-history/order-history.component';
import { ProductListComponent } from './components/products/product-list/product-list.component';
import { ReferredComponent } from './components/profile/referred/referred.component';
import { RegisterComponent } from './components/register-users/register/register.component';
import { SocialNetworkRegisterComponent } from './components/register-users/social-network-register/social-network-register.component';
import { SummaryComponent } from './components/profile/summary/summary.component';
import { SliderMenuComponent } from './components/profile/slider-menu/slider-menu.component';
import { ProductListResolver } from './_resolvers/product-list.resolver';
import { ProductViewComponent } from './components/products/product-view/product-view.component';
import { ProductViewResolver } from './_resolvers/product-view.resolver';
import { ProductCardComponent } from './components/products/product-card/product-card.component';
import { AddProductToShoppingCartComponent } from './modals/add-product-to-shopping-cart/add-product-to-shopping-cart.component';
import { ShoppingCartComponent } from './components/orders/shopping-cart/shopping-cart.component';
import { ShoppingCartResolver } from './_resolvers/shopping-cart.resolver';
import { PayOptionsComponent } from './modals/pay-options/pay-options.component';
import { ProductCharacteristicsComponent } from './components/products/product-characteristics/product-characteristics.component';
import { EpaycoResponseComponent } from './components/orders/epayco-response/epayco-response.component';
import { SearchComponent } from './components/search/search.component';
import { LoaderInterceptor } from './_interceptors/loader.interceptor';
import { PurchaseDetailComponent } from './components/profile/purchase-detail/purchase-detail.component';
import { HelpFormComponent } from './components/profile/help-form/help-form.component';
import { ShortOrderCodePipe } from './_pipes/short-order-code.pipe';
import { ServicesComponent } from './components/checkIn/services/services.component';
import { ServicesViewComponent } from './components/checkIn/services-view/services-view.component';



registerLocaleData(localePy, 'es');


@NgModule({
  declarations: [
    AppComponent,
    AlertDialogComponent,
    CarouselPromotionalProfileComponent,
    EditProfileComponent,
    FooterComponent,
    HeaderComponent,
    HomeComponent,
    LoaderComponent,
    LoginComponent,
    MenuComponent,
    OrderHistoryComponent,
    ReferredComponent,
    RegisterComponent,
    SliderMenuComponent,
    SocialNetworkRegisterComponent,
    SummaryComponent,
    ProductListComponent,
    FiltersComponent,
    ProductViewComponent,
    ProductCardComponent,
    AddProductToShoppingCartComponent,
    ShoppingCartComponent,
    PayOptionsComponent,
    ProductCharacteristicsComponent,
    EpaycoResponseComponent,
    SearchComponent,
    PurchaseDetailComponent,
    HelpFormComponent,
    ShortOrderCodePipe,
    ServicesComponent,
    ServicesViewComponent,
  ],
  imports: [
    AppRoutingModule,
    AngularFireAnalyticsModule,
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFirestoreModule,
    BrowserModule,
    BrowserAnimationsModule,
    FlexLayoutModule,
    FormsModule,
    HttpClientModule,
    MaterialModule,
    MatCarouselModule.forRoot(),
    NgxGalleryModule,
    ReactiveFormsModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production })
  ],
  providers: [
    DevicesService,
    ProductListResolver,
    ProductService,
    ProductViewResolver,
    ShoppingCartResolver,
    SidenavService,
    SocialNetworkRegisterResolver,
    {
      provide: LOCALE_ID, useValue: 'es'
    },
    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useValue: { hasBackdrop: false }
    },
    UserEditResolver,
    {
      provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true
    }
  ],
  bootstrap: [AppComponent],
  entryComponents:[LoginComponent, SearchComponent]
})
export class AppModule { }
